import { render, staticRenderFns } from "./PowerIndicators.vue?vue&type=template&id=685c815f&scoped=true&"
import script from "./PowerIndicators.vue?vue&type=script&lang=js&"
export * from "./PowerIndicators.vue?vue&type=script&lang=js&"
import style0 from "./PowerIndicators.vue?vue&type=style&index=0&id=685c815f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685c815f",
  null
  
)

export default component.exports